module.exports = __webpack_public_path__ + "static/Jeng-Oshiro-hug-4da8550df3f5e5750d1c88027900f657.jpg";